import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { DebounceInput } from 'react-debounce-input';

import { AzelRange, azElErrorMessage } from 'common/utils/constants';
import { isAzValid, isElValid } from 'common/utils/helpers';

import './CustomBeamRankItem.css';

const CustomBeamRankItem = (props) => {
  const { config = AzelRange } = props;
  const [localCustomAz, setLocalCustomAz] = useState(props.customAzEl?.az);
  const [localCustomEl, setLocalCustomEl] = useState(props.customAzEl?.el);
  const [switchInputKey, setSwitchInputKey] = useState(0);

  useEffect(() => {
    setLocalCustomAz(Number.isInteger(props.customAzEl?.az) ? props.customAzEl.az : '');
    setLocalCustomEl(Number.isInteger(props.customAzEl?.el) ? props.customAzEl.el : '');
    // if (props.customAzEl.az && props.customAzEl.el) {
    props.setAzElInputError &&
      props.setAzElInputError(props.customAzEl.deviceId, {
        az:
          Number.isInteger(props.customAzEl?.az) && !isAzValid(props.customAzEl?.az, config)
            ? azElErrorMessage.az(config)
            : null,
        el:
          Number.isInteger(props.customAzEl?.el) && !isElValid(props.customAzEl?.el, config)
            ? azElErrorMessage.el(config)
            : null
      });
    // }
  }, [config, props.customAzEl?.az, props.customAzEl?.el, switchInputKey, props.selectedBeamRankIndex]);

  return (
    <div className={classNames({ CustomBeamRankItem_Container: true })}>
      <div className="CustomBeamRankItem_RankingBox">
        <span className="CustomBeamRankItem_RankingBox_Title">Custom</span>
      </div>
      <div className="CustomBeamRankItem_CustomAzElBox">
        <div className="CustomBeamRankItem_CustomAzElBox_Values">
          <div
            className={classNames({
              CustomBeamRankItem_CustomAzElBox_Value: true,
              CustomBeamRankItem_CustomAzElBox_Value_Error: props.azElInputError.az || !isAzValid(localCustomAz, config)
            })}
          >
            <DebounceInput
              onChange={(evt) => {
                let inputVal = parseInt(evt.target.value);
                if (!Number.isInteger(inputVal)) {
                  setLocalCustomAz('');
                  props.setCustomAzEl(props.customAzEl.deviceId, { az: '', el: props.customAzEl.el });
                  return;
                }
                setLocalCustomAz(inputVal);
                if (!isAzValid(inputVal, config)) {
                  let newAzElInputError = {
                    az: azElErrorMessage.az(config),
                    el: props.azElInputError.el
                  };
                  props.setAzElInputError(props.customAzEl.deviceId, newAzElInputError);
                } else {
                  props.setAzElInputError(props.customAzEl.deviceId, { az: null, el: props.azElInputError.el });
                  props.setCustomAzEl(props.customAzEl.deviceId, { az: inputVal, el: props.customAzEl.el });
                }
              }}
              value={localCustomAz}
              debounceTimeout={1000}
              minLength={0}
              type={'number'}
              forceNotifyByEnter={true}
              forceNotifyOnBlur={true}
              onClick={(e) => {
                e.target.select();
                setSwitchInputKey(Math.random() * 10);
                props.setAzElInputError(props.customAzEl.deviceId, { az: null, el: null });
              }}
            />
          </div>
          <span>/</span>
          <div
            className={classNames({
              CustomBeamRankItem_CustomAzElBox_Value: true,
              CustomBeamRankItem_CustomAzElBox_Value_Error: props.azElInputError.el || !isElValid(localCustomEl, config)
            })}
          >
            <DebounceInput
              onChange={(evt) => {
                let inputVal = parseInt(evt.target.value);
                if (!Number.isInteger(inputVal)) {
                  setLocalCustomEl('');
                  props.setCustomAzEl(props.customAzEl.deviceId, { az: props.customAzEl.az, el: '' });
                  return;
                }
                setLocalCustomEl(inputVal);
                if (!isElValid(inputVal, config)) {
                  let newAzElInputError = {
                    az: props.azElInputError.az,
                    el: azElErrorMessage.el(config)
                  };
                  props.setAzElInputError(props.customAzEl.deviceId, newAzElInputError);
                } else {
                  props.setAzElInputError(props.customAzEl.deviceId, { az: props.azElInputError.az, el: null });
                  props.setCustomAzEl(props.customAzEl.deviceId, { az: props.customAzEl.az, el: inputVal });
                }
              }}
              value={localCustomEl}
              debounceTimeout={1000}
              minLength={0}
              forceNotifyByEnter={true}
              forceNotifyOnBlur={true}
              type={'number'}
              onClick={(e) => {
                e.target.select();
                setSwitchInputKey(Math.random() * 10);
                props.setAzElInputError(props.customAzEl.deviceId, { az: null, el: null });
              }}
            />
          </div>
        </div>
        <div className="CustomBeamRankItem_AzElBox_Details">{'(Az/El)'}</div>
      </div>
    </div>
  );
};

export default CustomBeamRankItem;
